import { useBreakpoints } from '@vueuse/core'
import resolveConfig from 'tailwindcss/resolveConfig'
import tailwindConfig from '@/tailwind.config'

const fullConfig = resolveConfig(tailwindConfig)

export const useBTBreakpoints = () => {
  const breakpoints = useBreakpoints(fullConfig.theme.screens)
  const { isDesktop: isDeviceDesktop, isMobile: isDeviceMobile, isTablet: isDeviceTablet } = useDevice()

  const isMobile = ref(isDeviceMobile)
  const isTablet = ref(isDeviceTablet)
  const isDesktopSmall = ref(isDeviceDesktop)
  const isDesktopLarge = ref(isDeviceDesktop)
  const isDesktop = ref(isDeviceDesktop)

  const updateResponsiveState = () => {
    isMobile.value = breakpoints.smaller('sm').value
    isTablet.value = breakpoints.between('sm', 'md').value
    isDesktopSmall.value = breakpoints.between('md', 'xl').value
    isDesktopLarge.value = breakpoints.greaterOrEqual('xl').value

    isDesktop.value = isDesktopSmall.value || isDesktopLarge.value
  }

  watch(breakpoints.active(), () => {
    updateResponsiveState()
  })

  onBeforeMount(() => {
    updateResponsiveState()
  })

  return {
    isMobile,
    isTablet,
    isDesktop,
    isDesktopSmall,
    isDesktopLarge
  }
}
